import { Link } from "react-router-dom";

export default function Privacy() {
    return (
        <main className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-20 min-h-screen">
            <p className="font-mono-tag text-xs uppercase text-brand-saffron mb-3">/ legal</p>
            <h1 data-testid="privacy-title" className="font-display font-extrabold text-4xl md:text-6xl tracking-tighter uppercase mb-3">
                Privacy <span className="text-brand-saffron">Policy</span>
            </h1>
            <p className="font-mono-tag text-[11px] uppercase text-white/50 mb-10">Last updated: Feb 28, 2026</p>

            <div className="prose prose-invert max-w-none space-y-6 text-white/80 leading-relaxed">
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">1. Who we are</h2>
                    <p>Primates ("we", "our", "the platform") is a curated discovery marketplace for fashion startups based in India. We link out to brand websites — we do not sell products directly.</p>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">2. What we collect</h2>
                    <ul className="list-disc pl-6 space-y-1.5">
                        <li><strong className="text-white">Account data</strong> — name, email and hashed password when you sign up.</li>
                        <li><strong className="text-white">Brand data</strong> — for founders: brand name, tagline, description, website, city, region, founder details, price range, craft story, uploaded logo/banner images.</li>
                        <li><strong className="text-white">Activity data</strong> — profile views, click-throughs to brand websites, drops posted, follows. Used to power brand analytics.</li>
                        <li><strong className="text-white">Session data</strong> — a signed JWT stored as an HTTP-only cookie or in local storage to keep you logged in.</li>
                    </ul>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">3. How we use it</h2>
                    <ul className="list-disc pl-6 space-y-1.5">
                        <li>To let you sign in and access your account.</li>
                        <li>To review brand applications and decide what gets listed publicly.</li>
                        <li>To power discovery, follow feeds and per-brand analytics for founders.</li>
                        <li>To improve the product — we may look at aggregate usage patterns.</li>
                    </ul>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">4. What we don't do</h2>
                    <p>We do <strong className="text-brand-saffron">not</strong> sell your personal data. We do not run third-party ad networks on Primates. We do not send marketing emails unless you opt in.</p>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">5. Third parties</h2>
                    <p>Uploaded media (images) is hosted on an Emergent-managed object storage service. Fonts are served by Google Fonts. Both operate under their own privacy terms.</p>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">6. Your rights</h2>
                    <p>You can request a copy of your data or ask us to delete your account by writing to <a href="mailto:primates.work@gmail.com" className="text-brand-saffron hover:underline">primates.work@gmail.com</a>. We'll respond within 30 days.</p>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">7. Cookies</h2>
                    <p>We use one essential session cookie (`access_token`) to keep you logged in. That's it — no tracking cookies, no cross-site pixels.</p>
                </section>
                <section>
                    <h2 className="font-display font-bold text-2xl text-white mt-2 mb-2">8. Contact</h2>
                    <p>Questions? <a href="mailto:primates.work@gmail.com" className="text-brand-saffron hover:underline">primates.work@gmail.com</a></p>
                </section>
            </div>

            <div className="mt-14 border-t border-white/10 pt-8">
                <Link to="/terms" className="font-mono-tag text-xs uppercase text-brand-saffron hover:underline">Read Terms & Conditions →</Link>
            </div>
        </main>
    );
}
